import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Legal.css';

const Cookies = () => (
  <div className="legal-page">
    <Header />
    <div className="legal-hero">
      <h1>Cookie Policy</h1>
      <p>Last updated: 02 - May - 2026</p>
    </div>
    <div className="legal-content">
      <section>
        <h2>1. What Are Cookies</h2>
        <p>Cookies are small text files stored on your device when you visit websites. They help websites remember your preferences and improve your browsing experience.</p>
      </section>
      <section>
        <h2>2. How We Use Cookies</h2>
        <p>We use essential cookies for website functionality, analytics cookies to understand site usage, and preference cookies to remember your settings.</p>
      </section>
      <section>
        <h2>3. Types of Cookies We Use</h2>
        <p><strong>Essential Cookies:</strong> Required for the website to function properly.</p>
        <p><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our site.</p>
        <p><strong>Functional Cookies:</strong> Remember your preferences and settings.</p>
      </section>
      <section>
        <h2>4. Managing Cookies</h2>
        <p>You can control and delete cookies through your browser settings. Disabling cookies may affect website functionality.</p>
      </section>
      <section>
        <h2>5. Third-Party Cookies</h2>
        <p>We may use third-party services like Google Analytics that set their own cookies. These are governed by their respective privacy policies.</p>
      </section>
      <section>
        <h2>6. Updates</h2>
        <p>We may update this cookie policy from time to time. Changes will be posted on this page.</p>
      </section>
      <section>
        <h2>7. Contact</h2>
        <p>For questions about cookies, contact <a href="mailto:info@musaelectricalkenya.co.ke">info@musaelectricalkenya.co.ke</a>.</p>
      </section>
    </div>
    <Footer />
  </div>
);

export default Cookies;
